// src/utils/gtm.ts
export function initGTM(gtmId: string, dataLayerName = 'dataLayer') {
  if (!gtmId || typeof window === 'undefined') return;
  const w = window as any;
  //Start create tag
  if (document.getElementById('gtm-script')) return;

  w[dataLayerName] = w[dataLayerName] || [];
  w[dataLayerName].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const firstScript = document.getElementsByTagName('script')[0];
  const gtmScript = document.createElement('script');
  gtmScript.id = 'gtm-script';
  gtmScript.async = true;

  const dlQuery = dataLayerName !== 'dataLayer' ? `&l=${dataLayerName}` : '';
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}${dlQuery}`;

  firstScript.parentNode?.insertBefore(gtmScript, firstScript);
}